import React from 'react';
import Analytics from '../components/Analytics';

const AnalyticsPage = () => (
  <div className="min-h-screen py-8 px-4">
    <Analytics />
  </div>
);

export default AnalyticsPage;
